// LOAD-PERF (owner 2026-11-02: "When I hit start run … it takes 10 to 20 seconds" / "Maybe add a loading screen"). The Start
// Run loading screen: the selected map's concept art (the same image as its map-select card), the map name, the time of day,
// a progress bar driven by the real steps (world, effects, shaders) with a status line, and a rotating tip. Same look as the
// boot loading screen (#loading, src/style.css). Shown on the click, before any heavy work; fades into the run when the
// warm-up is done. DOM only — it decides nothing about the game.

const TIPS = [
  'Fill the Surge bar, then press Surge to transform. Keep charging for a higher, stronger form.',
  'Traits stack with your skills: mix them to shape your build.',
  'A max-rank skill plus its paired trait evolves. Two max-rank skills that fuse become one stronger skill.',
  'Toggle the radar with N on the keyboard or R2 on a controller.',
  'Every normal run continues after the final boss. Run Setup controls difficulty, auto Surge, game speed and Power Ups.',
  'Elites drop Array Seals. Collect six for a Convergence boon.',
  'Fracture Shards from every run buy permanent upgrades in Power Ups.',
  'Fire spreads through grass and trees. Lure foes into it, or keep clear.',
  'Ice skills chill foes and freeze them solid; frozen foes take extra damage.',
  'Scroll the mouse wheel to zoom the camera in or out.',
  'The Encyclopedia fills in as you meet new foes, skills, traits, fusions and Surge forms.',
];

export class RunLoading {
  private el: HTMLElement | null = null;
  private shownAt = 0;
  private tipT = 0;
  private tipI = Math.floor(Math.random() * TIPS.length);
  private frac = 0;

  private build(): HTMLElement {
    const el = document.createElement('div');
    el.id = 'runloading'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<div class="rl-bg" aria-hidden="true"></div><div class="rl-box">'
      + '<div class="rl-tag">ENTERING</div><div class="rl-name"></div><div class="rl-tod"></div>'
      + '<div class="ld-bar rl-bar" aria-hidden="true"><div class="ld-fill det rl-fill"></div></div>'
      + '<p class="ld-msg rl-msg"></p><p class="rl-tip"></p></div>';
    document.body.appendChild(el);
    return el;
  }

  get visible(): boolean { return !!this.el && !this.el.classList.contains('out'); }

  /** show at once (call before the heavy work, then yield a frame so it paints) */
  show(mapName: string, concept: string, tod: string): void {
    const el = this.el ??= this.build();
    (el.querySelector('.rl-bg') as HTMLElement).style.backgroundImage = `url('${concept}')`;
    el.querySelector('.rl-name')!.textContent = mapName;
    el.querySelector('.rl-tod')!.textContent = tod;
    this.frac = 0; this.step(0, 'Entering the arena…');
    this.tipI = (this.tipI + 1) % TIPS.length; el.querySelector('.rl-tip')!.textContent = TIPS[this.tipI];
    clearInterval(this.tipT); this.tipT = window.setInterval(() => { this.tipI = (this.tipI + 1) % TIPS.length; const t = this.el?.querySelector('.rl-tip'); if (t) t.textContent = TIPS[this.tipI]; }, 4000);
    el.classList.remove('out'); this.shownAt = performance.now();
  }

  step(frac: number, msg: string): void {
    if (!this.el) return;
    this.frac = Math.max(this.frac, Math.min(1, frac));
    (this.el.querySelector('.rl-fill') as HTMLElement).style.width = `${Math.round(this.frac * 100)}%`;
    this.el.querySelector('.rl-msg')!.textContent = msg;
  }

  /** fade out; a load that was nearly instant still shows the screen for `minMs` as a clean transition (never padded beyond) */
  async hide(minMs = 450): Promise<void> {
    if (!this.el) return;
    this.step(1, 'Ready');
    const wait = minMs - (performance.now() - this.shownAt);
    if (wait > 0) await new Promise((r) => setTimeout(r, wait));
    clearInterval(this.tipT);
    this.el.classList.add('out');
  }
}

/** let the browser paint (two animation frames), so a screen shown just before a long synchronous step is on screen */
export const paint = (): Promise<void> => new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(() => r())));
